var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterLinkedinLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2410_32305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.494 24.0002L24.5 23.9992V15.1972C24.5 10.8912 23.573 7.57422 18.539 7.57422C16.119 7.57422 14.495 8.90222 13.832 10.1612H13.762V7.97622H8.98901V23.9992H13.959V16.0652C13.959 13.9762 14.355 11.9562 16.942 11.9562C19.491 11.9562 19.529 14.3402 19.529 16.1992V24.0002H24.494Z",
    fill: "#CBD1D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.895996 7.97656H5.872V23.9996H0.895996V7.97656Z",
    fill: "#CBD1D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.382 0C1.791 0 0.5 1.291 0.5 2.882C0.5 4.473 1.791 5.791 3.382 5.791C4.973 5.791 6.264 4.473 6.264 2.882C6.263 1.291 4.972 0 3.382 0Z",
    fill: "#CBD1D6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2410_32305"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLinkedinLight);
export default __webpack_public_path__ + "static/media/FooterLinkedinLight.4fb478efc041da747a2a84e31a909bb5.svg";
export { ForwardRef as ReactComponent };